export default __webpack_public_path__ + "static/media/hht1_ep12_timeline_q01_a.56010131.png";